import React from 'react';
import './ScrollingTitle.css';

const ScrollingTitle = ({ lines, className = "" }) => {
  return (
    <section className={`scrolling-title ${className}`}>
      <div className="scrolling-title-container">
        {lines.map((line, index) => (
          <div key={index} className="scrolling-title-text-line">
            <div className="scrolling-text scrolling-title-scroll" data-speed={line.speed}>
              <span className="scrolling-title-text">
                {Array(20).fill(null).map((_, index) => (
                  <span key={index} className={index === 1 ? 'solid' : 'outline'}>
                    {line.text}&nbsp;
                  </span>
                ))}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ScrollingTitle; 